import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  Card,
  Heading,
  Paragraph,
  Button,
  Table,
  SyncIcon,
  Input,
  FlexRow,
} from "ProtoType/Slack/styles/Common";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import {
  SG_GET_SLACK_SCHEDULER_SEARCH_EMPLOYEES,
  SG_GET_SLACK_SCHEDULER_ADD_EMPLOYEES,
} from "constants/actions";

const SlackAppSettings = ({organizationGroupId}) => {
  const dispatch = useDispatch();
  const [searchEmail, setSearchEmail] = useState("");

  const [selectedPrimaryCategory, setSelectedPrimaryCategory] = useState(false);
  const { get_slack_scheduler, get_surveystructure } =
    useSelector(
      (state) => ({
        get_slack_scheduler: state.slack_scheduler,
        get_surveystructure: state.surveystructure.survey_structure,
      }),
      shallowEqual
    );

  const handleSearch = () => {
    if (searchEmail) {
      dispatch({
        type: SG_GET_SLACK_SCHEDULER_SEARCH_EMPLOYEES,
        payload: `email=${searchEmail}`,
      });
    }
  };

  function AddEmployee(id) {
    dispatch({
      type: SG_GET_SLACK_SCHEDULER_ADD_EMPLOYEES,
      payload: { 
        id: organizationGroupId,
        employee_ids: [id] 
      },
    });
  }
  function searchEmployees() {
    if (selectedPrimaryCategory?.id) {
      dispatch({
        type: SG_GET_SLACK_SCHEDULER_SEARCH_EMPLOYEES,
        payload: `category=${selectedPrimaryCategory?.id}`,
      });
    }
  }

  const categoryArray = Object.values(
    get_surveystructure?.[0]?.category_dict?.value || {}
  );


  return (
    <Card>
      <Heading>Search Employees [Optional Search to Add]</Heading>

      <FlexRow>
        <div style={{ flex: 8 }}>
          <Select
            placeholder="Search Category"
            onChange={setSelectedPrimaryCategory}
            value={selectedPrimaryCategory}
            options={categoryArray}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
          />
        </div>
        <div style={{ flex: 2, textAlign: "right" }}>
          <Button
            onClick={searchEmployees}
            style={{ backgroundColor: "#007BFF", color: "#FFF" }}
          >
            Search
          </Button>
        </div>
      </FlexRow>
      <FlexRow>
        <Input
          type="text"
          placeholder="Search by email"
          value={searchEmail}
          onChange={(e) => setSearchEmail(e.target.value)}
          style={{
            borderColor: "#007BFF",
            marginRight: "8px",
            marginTop: "15px",
          }} // Highlight border and add margin
        />
        <Button
          onClick={handleSearch}
          style={{ backgroundColor: "#007BFF", color: "#FFF" }}
        >
          Search
        </Button>
      </FlexRow>

      <>
        <Paragraph></Paragraph>
        <Table>
          <thead>
            <tr>
              <th></th>
              <th>ID</th>
              <th>First</th>
              <th>Last </th>
              <th>Email</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {get_slack_scheduler?.employee_search &&
              get_slack_scheduler?.employee_search.map((user) => (
                <tr key={user.id}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>{user?.id}</td>
                  <td>{user?.first_name}</td>
                  <td>{user?.last_name}</td>
                  <td>{user.email}</td>
                  <td>{user?.status ? "Active" : "Not Active"}</td>
                  <td>
                    <Button
                      style={{
                        background: "#FFF",
                        color: "#DC3545",
                        borderColor: "#DC3545",
                      }}
                      onClick={() => AddEmployee(user.id)}
                    >
                      Add
                    </Button>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </>
    </Card>
  );
};

export default SlackAppSettings;
